<template>
  <div class="relative">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <div
          :id="keyIndex"
          class="pa-3 on-hover position-relative"
          :style="[
            isError && !fileName
              ? { border: '2px dotted red' }
              : { border: '2px dotted #b8b8b8' },
            disabled ? { pointerEvents: 'none', opacity: 0.6 } : {},
          ]"
          @dragover="dragover"
          @drop="drop"
          v-bind="fileName ? attrs : ''"
          v-on="fileName && !disabled ? on : ''"
        >
          <input
            type="file"
            name="fields[assetsFieldHandle][]"
            :id="'assetsFieldHandle' + keyIndex"
            style="display: none"
            @change="onChange"
            ref="file"
            :disabled="disabled"
            accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
          />
          <div class="d-flex justify-space-between">
            <label
              :for="'assetsFieldHandle' + keyIndex"
              class="block cursor-pointer d-flex align-center"
              :style="fileName ? 'max-width: 80%; overflow: hidden' : ''"
            >
              <div
                class="circular-add d-flex align-center justify-center mr-3"
                v-if="!fileName"
              >
                <v-icon color="primary">fas fa-plus</v-icon>
              </div>
              <div v-if="!fileName" style="cursor: pointer">
                Drag & Drop your file or
                <span class="primary--text font-weight-medium">Upload</span>
                <span v-if="Mandatory" style="color: red">*</span>
                <span v-else-if="dummyMandatory"> *</span>
              </div>
              <div v-else class="d-flex">
                <div class="text-truncate">
                  {{ fileName }}
                </div>
                <!-- <v-icon color="amber" size="30" class="ml-1">create</v-icon> -->
              </div>
            </label>
            <v-icon
              v-if="fileName"
              size="30"
              @click="deleteFileContent(oldFileName)"
              color="red"
              class="ml-1"
              >delete</v-icon
            >
          </div>
        </div>
        <div v-if="message && !isError" class="caption">
          {{
            isFileSizeExceed
              ? "Size of uploaded file is greater than 3MB"
              : "Maximum file size: 3 MB ; Supported formats: JPEG, JPG, PNG, PDF, DOC,DOCX"
          }}
        </div>
        <div v-else-if="isError && !fileName" class="caption red--text">
          {{ isError }}
        </div>
      </template>
      <span v-if="fileName">{{ fileName }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "DragAndDropFiles",

  props: {
    fileCategory: {
      type: String,
      required: true,
    },
    oldFileName: {
      type: String,
      required: true,
    },
    keyIndex: {
      type: String,
      default: "file-upload",
    },
    isError: {
      type: String,
      default: "",
    },
    message: {
      type: Boolean,
      default: false,
    },
    Mandatory: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dummyMandatory: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    fileName: "",
    isFileSizeExceed: false,
  }),

  computed: {
    folderName() {
      if (this.fileCategory?.toLowerCase() === "experience") {
        return "Employee Experience";
      } else if (this.fileCategory?.toLowerCase() === "accreditation") {
        return "Employee Accreditation";
      } else if (this.fileCategory?.toLowerCase() === "bank") {
        return "Employee Bank Details";
      }
      return "Employees Document Upload";
    },
    domain() {
      return this.$store.getters.domain;
    },
    orgCode() {
      let orgCode = localStorage.getItem("orgCode");
      return orgCode;
    },
  },

  mounted() {
    this.fileName = this.oldFileName?.split("?")[3] || "";
  },

  watch: {
    oldFileName(val) {
      this.fileName = val?.split("?")[3] || "";
    },
  },

  methods: {
    onChange() {
      if (this.disabled) return;
      let fileList = this.$refs.file.files[0];
      if (!fileList) return;
      const timestamp = moment().unix();
      if (fileList.size > 3000000) {
        this.isFileSizeExceed = true;
      } else {
        this.isFileSizeExceed = false;
        this.fileName = fileList.name;
        let candidateId = localStorage.getItem("Candidate_Id");
        // Format: candidateId?timestamp?documentType?filename
        let formattedName = `${candidateId || 0}?${timestamp}?1?${
          fileList.name || "document"
        }`;
        fileList.formattedName = formattedName;
        if (this.oldFileName) {
          this.onFileReplace(fileList);
        } else {
          this.uploadFileContents(fileList);
        }
      }
    },
    dragover(event) {
      if (this.disabled) return;
      event.preventDefault();
    },

    drop(event) {
      if (this.disabled) return;
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange();
    },

    async uploadFileContents(file) {
      this.$emit("file-event-triggered", true);
      let fileUploadUrl = `${this.domain}/${this.orgCode}/${this.folderName}/`;
      await this.$store
        .dispatch("s3FileUploadRetrieveAction", {
          fileName: fileUploadUrl + file.formattedName,
          action: "upload",
          type: "documents",
          fileContent: file,
        })
        .then(() => {
          this.$emit("file-event-success", file.formattedName);
          this.$emit("file-event-triggered", false);
        })
        .catch(() => {
          this.$emit("file-event-triggered", false);
        });
    },
    async deleteFileContent(fileName, replace) {
      if (this.disabled && !replace) return;
      this.$emit("file-event-success", "");
    },
    async onFileReplace(fileContent) {
      this.deleteFileContent(this.oldFileName, true);
      this.uploadFileContents(fileContent);
    },
  },
};
</script>
<style>
.circular-add {
  background: lightgrey;
  height: 35px;
  width: 35px;
  border-radius: 50%;
}
.on-hover::after {
  position: absolute;
  width: 100%;
  top: 0;
  content: "";
  background: var(--v-primary-base);
  opacity: 0.3;
  bottom: 0;
  left: 0;
  z-index: -1;
}
.on-hover {
  position: relative;
  z-index: 2;
}
</style>
